import moment from "moment";

export class Datointerval {
    static inneværendeOgForrigeMåned() {
        return new Datointerval(
            moment().startOf("month").subtract(1, "month").toDate(),
            moment().startOf("day").subtract(1, "millisecond").toDate());
    }

    static fraAngittDatoTilSluttenAvNesteMåned(dato: Date) {
        return new Datointerval(
            moment(dato).startOf("day").toDate(),
            moment(dato).add(1, "month").endOf("month").toDate());
    }

    static fraAngittDatoTilStartenAvForrigeMåned(dato: Date) {
        return new Datointerval(
        moment(dato).startOf("month").subtract(1, "month").toDate(),
        moment(dato).endOf("day").toDate())
    }

    static inneværendeÅr() {
        const start = moment().startOf("year").toDate();
        return new Datointerval(start, moment(start).endOf("year").toDate());
    }

    static inneværendeÅrUTC() {
        const start = moment().utc(true).startOf("year").toDate();
        return new Datointerval(start, moment(start).utc(true).endOf("year").toDate());
    }

    static årUTC(år:number) {
        const start = moment().utc(true).year(år).startOf("year").toDate();
        return new Datointerval(start, moment(start).utc(true).endOf("year").toDate());
    }

    static fraPeriode(periode: { start: Date; slutt: Date }) {
        return new Datointerval(periode.start, periode.slutt);
    }

    constructor(public readonly start: Date, public readonly slutt: Date) {
        this.start = start;
        this.slutt = slutt;
    }

    inkluderteMåneder(): Date[] {
        var måneder = [];
        var dato = moment(this.start).startOf("month");
        while (!dato.isAfter(this.slutt)) {
            måneder.push(dato.clone().toDate());
            dato.add(1, "month");
        }
        return måneder;
    }

    skiftToMndTidligere() {
        const slutt = moment(this.start).subtract(1, "millisecond").toDate();
        return new Datointerval(moment(slutt).startOf("month").subtract(1, "month").toDate(), slutt);
    }

    skiftToMndSenere() {
        const start = moment(this.slutt).add(1, "millisecond").toDate();
        return new Datointerval(start, moment(start).add(1, "month").endOf("month").toDate());
    }

    antallMåneder(): number {
        return moment(this.start).twix(this.slutt).count('months');
    }
}
